import axiosNest from '../../api/axiosNest';
import { toErrorMessage } from '../userOffers/orderActionsApi';

/**
 * CS w wersji lekkiej — klient API (`apps/api/src/cs-work/`; paczka
 * p. Mariusza 21.10, BR-CS-10 i BR-CS-11; przełącznik `csLight`,
 * S-21.10-16). Z systemu nic nie jest wysyłane — CS wpisuje, co ustalił.
 */
export const FEATURE_CS_LIGHT = 'csLight';

/** Kanały i wyniki awizacji — kody z API (dane), napisy jak w API. */
export const CONTACT_CHANNELS: ReadonlyArray<{ id: string; name: string }> = [
  { id: 'phone', name: 'telefon' },
  { id: 'email', name: 'mail' },
  { id: 'platform', name: 'platforma' },
];

export const AVIZATION_RESULTS: ReadonlyArray<{ id: string; name: string }> = [
  { id: 'confirmed', name: 'potwierdzono termin' },
  { id: 'change_requested', name: 'prośba o zmianę terminu' },
  { id: 'no_contact', name: 'brak kontaktu — ponowić' },
  { id: 'other', name: 'inny wynik' },
];

/** Najkrótsza notatka — jak w API. */
export const MIN_NOTE_TEXT = 3;

export interface ClientContact {
  id: number;
  kind: string;
  kindLabel: string;
  channel: string | null;
  channelLabel: string | null;
  result: string | null;
  resultLabel: string | null;
  text: string | null;
  createdByName: string | null;
  createdAt: string;
}

export async function fetchClientContacts(
  userOfferId: number | string,
): Promise<{ items: ClientContact[]; canWrite: boolean }> {
  const { data } = await axiosNest.get<{ items: ClientContact[]; canWrite: boolean }>(
    `/user-offers/${userOfferId}/client-contacts`,
  );
  return { items: data?.items ?? [], canWrite: !!data?.canWrite };
}

export async function addClientContact(
  userOfferId: number | string,
  entry: { kind: 'avization' | 'note'; channel?: string; result?: string; text?: string },
): Promise<ClientContact> {
  const { data } = await axiosNest.post<ClientContact>(`/user-offers/${userOfferId}/client-contacts`, entry);
  return data;
}

export interface CsCase {
  key: string;
  kind: string;
  kindLabel: string;
  // Raporty (P2) i zapytania (P3) — integracja 26.10.2026.
  target: { resource: 'pre-orders' | 'user-offers' | 'client-avizations' | 'client-reports' | 'inquiries'; id: number };
  title: string;
  clientName: string | null;
  location: string | null;
  deadline: string | null;
  criticality: 'urgent' | 'high' | 'normal';
  criticalityLabel: string;
  criticalityReason: string;
  executor: string;
  executorLabel: string;
  /** Przypomnienie: niewykonane po terminie (komunikacja z klientem, 26.10.2026). */
  reminder?: boolean;
}

export interface CsQueue {
  items: CsCase[];
  total: number;
  kinds: Array<{ id: string; name: string }>;
  executors: Array<{ id: string; name: string }>;
}

/** Filtry kolejki — klucze to kontrakt z API (`cs-work.controller.ts`). */
export interface CsQueueFilter {
  client?: string;
  location?: string;
  kind?: string;
  executor?: string;
  /** Tylko przypomnienia — `'true'` (kafelek pulpitu, 26.10.2026, pakiet P1). */
  reminder?: string;
}

export async function fetchCsQueue(filter: CsQueueFilter): Promise<CsQueue> {
  const params = Object.fromEntries(Object.entries(filter).filter(([, v]) => (v ?? '').trim() !== ''));
  const { data } = await axiosNest.get<CsQueue>('/cs-queue', { params });
  return {
    items: data?.items ?? [],
    total: data?.total ?? 0,
    kinds: data?.kinds ?? [],
    executors: data?.executors ?? [],
  };
}

export { toErrorMessage };
